import { fm } from 'Components/FormatMessage';
import { TESSearchField } from '../definitions';
import { TCommonESSearchFields } from '../definitions/common';
import { TMsESSearchFields } from '../definitions/ms';

export const msExtendedSearchFields = (searchFields?: TCommonESSearchFields & TMsESSearchFields): TESSearchField[] => [
  {
    name: 'gender',
    type: 'Radio',
    options: ['male', 'female'],
  },
  {
    name: 'age',
    type: 'RangeSlider',
    min: 0,
    max: 100,
    showRangeText: true,
    marks: [{ value: 33 }, { value: 66 }],
  },
  {
    name: 'diagnosis',
    type: 'Checkbox',
    options: ['keo', 'radiologicallyIsolatedSyndrome', 'ms', 'nmosd'],
  },
  {
    name: 'diagnosisDate',
    type: 'Custom',
  },
  {
    name: 'patientAgeOnDg',
    type: 'RangeSlider',
    min: 0,
    max: 100,
    showRangeText: true,
    marks: [{ value: 33 }, { value: 66 }],
  },
  {
    name: 'typeOfDisease',
    type: 'Checkbox',
    options: ['RR', 'SP', 'PP', 'cantDefine'] as TMS[],
    condition: Array.isArray(searchFields?.diagnosis) && searchFields.diagnosis.includes('ms'),
  },
  {
    name: 'medication',
    type: 'Custom',
    title: 'diseaseModifyingMedication',
  },
  {
    name: 'substance',
    type: 'Custom',
  },
  {
    name: 'relapseDuringLast24Months',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'relapseDuringLast12Months',
    type: 'Custom',
    condition: searchFields?.relapseDuringLast24Months !== 'no',
  },
  {
    name: 'edss',
    type: 'MultiSelect',
    options: [0, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10],
    tooltips: [
      { index: 0, message: fm('neurologicalStatusAndEDSS.edssStep.opts.0') },
      { index: 1, message: fm('neurologicalStatusAndEDSS.edssStep.opts.1.0') },
      { index: 2, message: fm('neurologicalStatusAndEDSS.edssStep.opts.1.5') },
      { index: 3, message: fm('neurologicalStatusAndEDSS.edssStep.opts.2.0') },
      { index: 4, message: fm('neurologicalStatusAndEDSS.edssStep.opts.2.5') },
      { index: 5, message: fm('neurologicalStatusAndEDSS.edssStep.opts.3.0') },
      { index: 6, message: fm('neurologicalStatusAndEDSS.edssStep.opts.3.5') },
      { index: 7, message: fm('neurologicalStatusAndEDSS.edssStep.opts.4.0') },
      { index: 8, message: fm('neurologicalStatusAndEDSS.edssStep.opts.4.5') },
      { index: 9, message: fm('neurologicalStatusAndEDSS.edssStep.opts.5.0') },
      { index: 10, message: fm('neurologicalStatusAndEDSS.edssStep.opts.5.5') },
      { index: 11, message: fm('neurologicalStatusAndEDSS.edssStep.opts.6.0') },
      { index: 12, message: fm('neurologicalStatusAndEDSS.edssStep.opts.6.5') },
      { index: 13, message: fm('neurologicalStatusAndEDSS.edssStep.opts.7.0') },
      { index: 14, message: fm('neurologicalStatusAndEDSS.edssStep.opts.7.5') },
      { index: 15, message: fm('neurologicalStatusAndEDSS.edssStep.opts.8.0') },
      { index: 16, message: fm('neurologicalStatusAndEDSS.edssStep.opts.8.5') },
      { index: 17, message: fm('neurologicalStatusAndEDSS.edssStep.opts.9.0') },
      { index: 18, message: fm('neurologicalStatusAndEDSS.edssStep.opts.9.5') },
      { index: 19, message: fm('neurologicalStatusAndEDSS.edssStep.opts.10') },
    ],
    style: { display: 'flex', justifyContent: 'center', width: '2rem' },
  },
  {
    name: 'edssIncreasedDuringLast24Months',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'edssIncreasedDuringLast12Months',
    type: 'Radio',
    options: ['yes', 'no'],
    condition: searchFields?.edssIncreasedDuringLast24Months !== 'no',
  },
  {
    name: 'spmsCriteria',
    type: 'Checkbox',
    options: ['expand', 'lorscheider'],
  },
  {
    name: 'myServiceInUse',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'includeDeceased',
    type: 'Radio',
    options: ['yes', 'no'],
  },
];

export const defaultMsSearchValues: TMsESSearchFields = {
  typeOfDisease: 'noCropping',
  relapseDuringLast24Months: 'noCropping',
  relapseDuringLast12Months: 'noCropping',
  numberOfRelapses: 'noCropping',
  edss: 'noCropping',
  edssIncreasedDuringLast24Months: 'noCropping',
  edssIncreasedDuringLast12Months: 'noCropping',
  spmsCriteria: 'noCropping',
  patientAgeOnDg: 'noCropping',
};
